<template>

  <q-page class="flex flex-center q-pa-md" >
     <div class="column items-center"> 
            <div class="col">
       <!-- <transition-group appear :duration="{ enter: 1500, leave: 800 }" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" class="group"> -->
              <q-card key="brand" inline style="font-family: 'Poppins', sans-serif; background-color: #fff; border-radius: 1rem; border: 1px solid white; " class="flex flex-center q-pa-lg">
                <div class="column">
                  <!-- <img id="logo" src="https://nadiablob.blob.core.windows.net/assets/aham-logo-bw-transparentbg.png" alt="logo"/> -->
                  <q-card-section class="row" style="">
                    
                    <div style="flex: auto;">
                    <div class="text-h6 text-center text-bold">Login to Your Account</div>
                    <!-- <div class="q-caption text-center">i-ACCESS MEMBER LOGIN</div> -->
                    </div>
                </q-card-section> 
                <q-card-section>
                <q-form @submit="onSubmit" @back="onBack" class=""> 
                <!--  <q-btn round flat color="blue" icon="fas fa-chevron-left" @click="$router.go(-1)"/>
                    <q-btn round size="sm" color="blue" @click="$router.go(-1)">
                      <q-icon name="arrow_back"></q-icon>
                    </q-btn> -->
         <!--          <div class="well text-center" style="color: red">
                      The image and security phrase below is a security measure to ensure that you are logging to <strong>https://i-access.affinhwangam.com</strong>.<br>Is this your chosen image? If NOT, please <strong>DO NOT</strong> enter your password.
                  </div> --> 
                  <div class="row">
                  <!--   <div class="col-md-12 text-center">
                        <div>
                            <img :src="getImgUrl()" v-bind:alt="pic" style="width:120px;">
                        </div>                        
                        <br>
                        <div>
                            Security Phrase: {{security}}                                       
                        </div>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-12" >
                      Username
                      <q-input  readonly bg-color="white" rounded outlined key="text" v-model="UserName" :before="[{icon: 'fas fa-user-circle', handler () {}}]" :rules="[val => !!val || 'Username is required']" >
                        <template v-slot:prepend>
                            <q-icon name="far fa-user-circle" />
                        </template>
                      </q-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      Password
                      <q-input bg-color="white" rounded outlined key="text" v-model="pwd" :type="isPwd ? 'password' : 'text'" ref="Password"  :before="[{icon: 'fas fa-user-circle', handler () {}}]" :rules="[val => !!val || 'Password is required']">
                          <template v-slot:prepend>
                              <q-icon name="lock" />
                          </template>
                          <template v-slot:append>
                            <q-icon
                              :name="isPwd ? 'visibility_off' : 'visibility'"
                              class="cursor-pointer"
                              @click="isPwd = !isPwd"
                            />
                          </template>
                      </q-input>
                    </div>
                  </div>
                 <!--  <div class="row">
                      <div class="col">
                          <q-btn  rounded 
                                size="lg" class="input-group" label="Let's Go!" :loading="submitting" type="submit" color="primary">
                          </q-btn>
                      </div>
                  </div> -->

                   <div class="row q-pt-sm">
                     <div class="col-3 q-pt-md q-pr-sm">
                       <q-btn outline size="lg" square color="grey-13" icon="fas fa-chevron-left" @click="$router.go(-1)" style="height: 100%; border-radius: 0.5rem; width: 52px;"/>
                     </div>
                
                            <div class="col-9 q-pt-md">

                                <q-btn
                                  unelevated
                                  size="lg"
                                  
                                  :loading="submitting"
                                  label="Let's Go!"
                                  type="submit" 
                                  class="" 
                                  style="width: 100%; background: #ff6666; color: white; border-radius: 0.5rem;">
                                </q-btn>
                            </div>
                        </div>
                        
                </q-form>
                </q-card-section>
                </div>
              </q-card>
        <!-- </transition-group> -->
            </div>
            </div>
          <!--   <q-page-container class="no-shadow" borderless>
              
      </q-page-container>
    <div class="flex flex-center column">
      
      <div class="fit row no-wrap justify-center items-start content-start">
        
          <div class="col-4 q-pa-lg bg-white page">
               <q-form @submit="onSubmit" @back="onBack" class="q-gutter-lg"> 
                   <q-btn round flat color="primary" icon="fas fa-chevron-left" @click="$router.go(-1)"/>
                    <div class="well text-center" style="color: red">
                        The image and security phrase below is a security measure to ensure that you are logging to <strong>https://i-access.affinhwangam.com</strong>.<br>Is this your chosen image? If NOT, please <strong>DO NOT</strong> enter your password.
                    </div>

                    <div class="row">
                      <div class="col-md-12 text-center">
                          <div>
                              <img :src="getImgUrl()" v-bind:alt="pic" style="width:120px;">
                          </div>                        
                          <br>
                          <div>
                              Security Phrase: {{security}}                                       
                          </div>
                      </div>
                    </div>

                    
                    <br>
                    <div class="row">
                      <div class="col-2">
                        <div style="margin-block-start: 0.55rem; margin-block-end: 0.55rem; font-weight:500;">User ID</div>
                      </div>
                      <div class="col">
                    <q-input dense standout v-model="UserName" disable readonly > </q-input>
                    </div>
                      </div>
                      <div class="row">
                        <div class="col-2">
                            <div style="margin-block-start: 0.55rem; margin-block-end: 0.55rem; font-weight:500;">Password</div>
                        </div>
                        <div class="col">
                    <q-input 
                    outlined 
                    dense 
                    v-model="pwd" 
                    type="password" 
                    placeholder="Password" 
                    class="div-group"
                    :rules="[val => !!val || 'Please key in your password.']" 
                    >
                      <template v-slot:after>
                          <div style="padding-left:0 !imporatnt">
                          <q-btn label="Submit" type="submit" color="primary" class="input-group"></q-btn>
                          </div>
                      </template>          
                    </q-input>
                      </div>
                    </div>

                      
               </q-form>
          </div>
      </div>
    </div> -->
   
  </q-page>
</template>

<script>
import { mapState, mapActions } from "vuex";

import store from '../store';
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  components: {
    
    FooterComponent
  },
    data() {
    return {
      pwd: null,
      security: null,      
      submitting: false,
      apiCall : true,      
      isPwd: true,
      counter:1,
      StoreStateLogin: store.state.Login,
      StoreStateAPI: store.state.API,
    };
  },
  computed: {
    ...mapState({
      UserName: state => state.Login.UserName,
      UserStatusId: state => state.Login.UserStatusId,
      LoginMessage: state => state.Login.Message,
      StatusName: state => state.Login.StatusName,
      SecurityPhrase: state => state.Login.SecurityPhrase,
      SecurityIconDocumentId: state => state.Login.SecurityIconDocumentId,
      IsSuccessful: state => state.Login.IsSuccessful,
      Session: state => state.Login.Session,
      RouteToPath: state => state.Login.RouteToPath
    })

    
  },
  mounted() {
 
      this.$refs.Password.$el.focus()
    this.getRandomSecurityPhase();
  },
  methods: {
    ...mapActions(["AuthLogin","AuthToken","GetApiToken", "GETEmisToken"]),
    getImgUrl() {
        var imgname
        (this.IsSuccessful) ? 
                imgname = this.SecurityIconDocumentId.trim().toString() : imgname = (Math.floor(Math.random() * 6) + 6).toString(); 
        
        var images = require.context('../assets/img/security-icons/', false, /\.jpg$/)
        return images('./' + imgname + ".jpg")
    },
    getRandomSecurityPhase(){
        var question
        var questions = ["Every cloud has a silver lining", "Curiosity killed the cat", "White Elephant", 
        "Red Hibiscus", "Pineapple Tart", "Green Apple", 
        "Your childhood nickname","Name of your favourite pet","Name of your elementary/primary school",
        "The city you were born in", "Your mother’s maiden name"];
        (this.IsSuccessful) ? 
                question = this.SecurityPhrase.trim().toString() : question = questions[(Math.floor(Math.random() * 11) + 1)]; 
        this.security = question
    },
    onSubmit () {
      this.submitting = true
      if (this.pwd) {
        //go to next page, while routing to there function to route to specific pages
        //TODO: to read message which page to go then route to
        var vm = this;
        this.AuthLogin({
          username: this.UserName,
          password: this.pwd
        }).then((returnVal) => {
            if ((this.UserStatusId === true)||(this.UserStatusId === 'true')){
              this.AuthToken()
              .then(async (res) => {
                  if ((this.UserStatusId === true)||(this.UserStatusId === 'true')){
                
                    while(this.counter<5){
                      await this.retrieveApiToken()
                      .then(res=>{
                        if((this.counter===4)&&(this.apiCall===false)){
                          this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + '-> Unable to retrieve API TOKEN' 
                          });
                          this.$router.push({ name: 'Maintenance'});
                         // console.log('error ->' + this.counter)
                        }

                      })
                      this.counter++
                      
                   } 
                  }else if ((this.UserStatusId === false)||(this.UserStatusId === 'false')){
                    this.$q.notify({
                      message: this.LoginMessage ,
                      color: 'red'
                    })
                    
                    this.$refs.Password.$el.focus()
                    this.submitting = false
                  }else{
                      this.$q.notify({
                      message: 'Something went wrong with login API. Please contact our Sales Support team to check on your login credentials' ,
                      color: 'red'
                    })
                  }
              })
            /*   vm.$router.push({
                path: this.StoreStateLogin.RouteToPath
              }); */
           }else if ((this.UserStatusId === false)||(this.UserStatusId === 'false')){
             this.$q.notify({
              message: this.LoginMessage ,
              color: 'red'
            })
            
            this.$refs.Password.$el.focus()
            this.submitting = false
           }else{
              this.$q.notify({
              message: 'Something went wrong with login API. Please contact our Sales Support team to check on your login credentials' ,
              color: 'red'
            })
           }
        })
      }
      else {
        //TODO: return error message password needed

      }
    },
    onBack() {
      //TODO: Route back to main page

    },

    retrieveApiToken(){
      return new Promise((resolve, reject) => {
        try{
          // this.GetApiToken()
          this.GETEmisToken({
            ApplicationId: this.StoreStateLogin.incomingAppID
          })
          .then((res) => {

            // Set Akamai Token to APIM
            this.$httpClient.defaults.headers['Authorization'] = "Bearer " + this.StoreStateLogin.AkamaiToken

            if ((this.UserStatusId === true)||(this.UserStatusId === 'true')){
              
              this.apiCall = true
              this.counter = 4
              this.$router.push({
                path: this.StoreStateLogin.RouteToPath
              });  
               resolve(this.apiCall)               
              return false 
            }else{              
              this.apiCall = false
              resolve(this.apiCall)
            }
        
          })
        }catch(err) {
          this.apiCall = false
          reject( this.apiCall)
        }
      })
       
    }
  }
}
</script>
<style>
#logo {
    max-width: 220px !important;
    max-height: 115px !important;
    margin: auto;
    image-rendering: -webkit-optimize-contrast;
}

.userID>.q-field>.q-field__inner >.q-field__control >.q-field__prepend,
.userID>.q-field>.q-field__inner >.q-field__control >.q-field__control-container>.q-field__label,
.userID>.q-field>.q-field__inner >.q-field__control >.q-field__control-container> .q-field__native {
  color:black
}


.userPassword>.q-field>.q-field__inner >.q-field__control >.q-field__prepend,
.userPassword>.q-field>.q-field__inner >.q-field__control >.q-field__control-container>.q-field__label,
.userPassword>.q-field>.q-field__inner >.q-field__control >.q-field__control-container> .q-field__native {
  color:black
}


</style>